/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/13
 * Time: 10:53
 * Desc:期刊管理
 */

import { Component, Vue, Watch } from 'vue-property-decorator';
import collect from 'collect.js';
import VueQArt from 'vue-qart';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import { cloneDeep } from 'lodash';
import { isTypeElement } from 'typescript';
import commentList from './commentList';
import { IPSService } from '@/services/ipsServices';
import { QinggerLibUtils, noop, parseSec } from '@/util';
import Timer = NodeJS.Timer;
import { Functions } from '@/library/utils/functions';
import NoAuth from '@/views/components/noAuth/noAuth.vue';
// import comSiteTreeList from '@/views/components/comSiteTreeList/index.vue';
import imgPreview from '@/views/components/imgPreview';
import { appEnvConfig } from '@/configs/appConfigs';
import { downloadFile } from '@/library/sheet/buffer';
import ExportFile from '@/views/components/exportFile';
import NewSelectSite from '@/views/components/newSelectSIte';
const isset = QinggerLibUtils.isset;
// import { Functions } from "@/library/utils/functions";
// 1活动结果追踪(大区) 2.活动结果追踪(网点) 3直播销售店铺导出 4.直播店铺销售导出 5期刊运营数据总计 6期刊运营数据明细
const exportType = {
  ACTIVITY_REASULT_GROUP: 1,
  ACTIVITY_REASULT_SITE: 2,
  LIVE_REASULT_SITE: 3,
  LIVE_REASULT_SITE_SALES: 4,
  QIKAN_OPERATION: 5,
  QIKAN_OPERATION_INFO: 6,
};
const exportTypeStr = {
  ACTIVITY_REASULT_GROUP: 'ACTIVITY_REASULT_GROUP',
  ACTIVITY_REASULT_SITE: 'ACTIVITY_REASULT_SITE',
  LIVE_REASULT_SITE: 'LIVE_REASULT_SITE',
  LIVE_REASULT_SITE_SALES: 'LIVE_REASULT_SITE_SALES',
  QIKAN_OPERATION: 'QIKAN_OPERATION',
  QIKAN_OPERATION_INFO: 'QIKAN_OPERATION_INFO',
  QIKAN_LIST: 'QIKAN_LIST',
};

@Component({
  components: {
    VueQArt,
    NoAuth,
    // comSiteTreeList,
    ExportFile,
  },
})
export default class PeriodicalManage extends Vue {
  moment = moment;
  /**
   * 关键字
   * @type {string}
   */
  public keywords = '';

  /**
   * 期刊状态
   * @type {string}
   */
  public peridicalState = '';

  public publishPlatform: number | string = '';

  /**
   * 是否显示评论列表
   * @type {boolean}
   */
  public isShowComment = false;

  /**
   * 是否显示二维码
   * @type {boolean}
   */
  public isShowCode = false;

  /**
   * 分
   * @type {number}
   */
  public Minute = 0;

  /**
   * 秒
   * @type {number}
   */
  public Second = 0;

  /**
   * 定时器
   * @type {number}
   */
  public timer: Timer = null;

  /**
   * 期刊id
   * @type {number}
   */
  // protected periodicalId: number = 0;

  /**
   * loading状态
   * @type {number}
   */
  public loadingState = true;

  public date = [];

  public defaultStart: Date | number;

  public defaultEnd: Date | number;
  /**
   * 店铺多级选择器字段对应设置
   * @type {object}
   */
  public theProps: object = {
    value: 'code',
    label: 'name',
    children: 'children',
  };

  /**
   * 留言状态
   * @type {Array<any>}
   */
  public commentStatus: Array<any> = [
    {
      value: 0,
      label: '隐藏',
    },
    {
      value: 1,
      label: '显示',
    },
  ];

  /**
   * 期刊状态
   * @type {Array<any>}
   */
  public periodicalStatus: Array<any> = [
    {
      value: 0,
      label: '导购下架',
    },
    {
      value: 1,
      label: '进行中',
    },
    {
      value: 2,
      label: '已过期',
    },
    {
      value: 3,
      label: '后台下架',
    },
  ];

  public publishPlatformStatus: Array<any> = [
    {
      value: 1,
      label: '小程序',
    },
    {
      value: 2,
      label: '后台',
    },
  ];

  /**
   * 选中的期刊
   * @type {Array<any>}
   */
  public multipleSelection: Array<any> = [];

  /**
   * 是否选中期刊
   * @type {boolean}
   */
  public isSelected = false;

  /**
   * 选中的留言
   * @type {Array<any> }
   */
  public selectedComments: Array<any> = [];

  /**
   * 留言状态
   * @type {string}
   */
  public comStatus = '';

  /**
   * 搜索留言的关键字
   * @type {string}
   */
  public comKeyword = '';

  /**
   * 是否选中留言
   * @type {boolean}
   */
  public isComments = false;

  /**
   * 期刊列表（api)
   * @type {Array<QiKanDistributeInfo>}
   */
  public periodicalList: Array<QiKanDistributeInfo> = [];

  public empCode = '';
  /**
   * 期刊列表条数
   * @type {number}
   */
  public countNum = 0;

  /**
   * 期刊列表页码
   * @type {number}
   */
  public qkPage = 1;

  /**
   * 期刊列表请求参数
   * @type {PeriodicalRequestParam}
   */
  public requestParams: PeriodicalRequestParam = {};

  public siteId = 0

  /**
   * 留言列表请求参数
   * @type {CommentsRequestParam}
   */
  public commentParams: CommentsRequestParam = {
    siteCodes: [],
  };

  /**
   * 二维码配置
   * @type {CommentsRequestParam}
   */
  public imageView = '';

  /**
   * 网点列表(API)
   * @type {Array}
   */
  public siteList: ItemArray<OrgSiteTreeNodeInfo> = [];

  /**
   * 选择的网点
   * @type {ItemArray<any>}
   */
  public siteValue: ItemArray<any> = [];

  /**
   * 选择店铺后的导购列表
   * @type {ItemArray<any>}
   */
  public guiderList: ItemArray<GuiderInfo> = [];

  /**
   * 导购名称
   * @type {number}
   */
  public guiderName = '';

  /**
   * 评论列表
   * @type {ItemArray<QiKanCommentInfo>}
   */
  public commentList: ItemArray<QiKanCommentInfo> = [];

  /**
   * 评论数量
   * @type {number}
   */
  public commentCount = 0;

  /**
   * 要显示的留言数量
   * @type {number}
   */
  public displayCount = 0;

  /**
   * 留言列表的当前页
   * @type {number}
   */
  public commentPage = 1;

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;

  /**
   * 发布期刊弹框是否显示
   * @type {boolean}
   */
  public qiKanVisible = false;

  public createQiKanVisible = false;

  public createQiKanSiteCode = '';
  public createQiKanLink = '';

  /**
   * 网店运营数据是否显示
   * @type {boolean}
   */
  public isScaleTableVisible = false;
  public saleNumberLoading = false;
  public nodeList = [];
  public defaultExpandedKeys = [];
  public saleNumberKeywords = '';
  public saleNumberSiteList = [];
  public saleSitePage = 1;
  public saleListLoading = false;
  public saleSitePageSize = 10;
  public saleSiteTotalCount = 0;
  public isSocketReady = false;
  public sendToIdList = [];
  // 当前期刊适用的网点codelist
  public siteCodeList = [];

  // 网点树选中项下的siteCode集合
  public siteCodeListAsTree = [];
  public qiKanId = 0;
  public tableDataType = 1; // 1、运营数据 2、销售数据 3、留言
  // 选中sitecode list
  public targetSiteCodes: any;

  // 新建期刊选择的类型
  public qiKanSelectType = 1;


  /**
   * 节点key
   * @type {Object}
   */
  public defaultProps: Object = {
    children: 'children',
    label: 'name',
  };

  /**
   *  导出按钮的信息
   * @type {ItemObject}
   */
  public exportBtnInfo: Array<ItemObject> = [
    { state: 0, url: '' }, //
    { state: 0, url: '' }, // 运营数据
    { state: 0, url: '' }, // 销售数据
    { state: 0, url: '' }, // 期刊列表导出
  ];

  getEditState(row) {
    return row.operAuthority && (row.qiKanState === 1 || row.qiKanState === 3);
  }

  /**
   * 鼠标移入表头提示
   * @param h
   * @param {any} column
   * @returns {any}
   */
  public headerTip(h, { column }): any {
    const contentTip = `点击按照${column.label}排序`;
    return h('el-tooltip', { attrs: { class: 'item', effect: 'light', content: contentTip, placement: 'bottom' } }, [h('span', {}, column.label)]);
  }

  /**
   * 当前选择的期刊状态
   * @param {number} value
   * @return null
   */
  public selectStatus(value: any): void {
    this.requestParams.qiKanState = value;
    if (value === 'all') { delete this.requestParams.qiKanState; }
    this.requestParams.page = 1;
    this.qkPage = 1;
    this.getPeriodicalList();
  }

  public selectPublishPlatform(value: any): void {
    this.requestParams.publishPlatform = value;
    if (value === 'all') { delete this.requestParams.publishPlatform; }
    this.requestParams.page = 1;
    this.qkPage = 1;
    this.getPeriodicalList();
  }

  public dateChange() {
    this.requestParams.page = 1;
    this.getPeriodicalList();
  }

  /**
   * 清空选择项
   * @return null
   */
  public setQKStatus(): void {
    this.requestParams.qiKanState = 10;
  }

  public setCMStatus() {
    this.commentParams.state = 9;
  }

  /**
   * 监听弹窗
   */
  @Watch('isScaleTableVisible')
  watchIsScaleTableVisible(newVal) {
    if (!newVal) {
    }
  }

  /**
   * 当前选中的店铺
   * @return null
   */
  public selectSite(value) {
    this.siteValue = value;
    const arr = JSON.parse(JSON.stringify(value));
    this.requestParams.guiderCode = '';
    this.requestParams.page = 1;
    this.qkPage = 1;
    this.requestParams.siteCode = arr.pop();
    this.getPeriodicalList();
    if (!isEmpty(value)) {
      // 获取导购列表
      const empParam = {
        siteCode: this.requestParams.siteCode,
        type: 'QIKAN',
      };
      this.guiderName = '';
      this.getGuiderList(empParam);
    }
  }
/**
   * 点击节点
   * @param {string} data
   * @return null
   */
 public handleNodeClick(data): void {
  this.saleSitePage = 1;
  this.saleSitePageSize = 10;
  this.saleNumberKeywords = '';
  if (this.tableDataType < 3) {
    // 点击节点时显示销售数据
    if (data.isSite) {
      this.onSiteDataInfo(data.code);
    } else {
      this.targetSiteCodes = [];
      this.findTargetSiteCodeList(data);
      const siteCodeList = this.targetSiteCodes.map((i) => {
        return i.code;
      });
      this.tableDataType = 1;
      this.siteCodeListAsTree = siteCodeList;
      this.getOperationDataList();
    }
  }
}
  /**
   * 根据选择的店铺获取店铺的导购列表
   * @param queryParams
   * @return null
   */
  public getGuiderList(queryParams): void {
    this.guiderList = [];
    IPSService.getGuiderListBySiteCode({ queryParams }).then((responseData) => {
      if (isset(responseData, 'list')) {
        this.guiderList = responseData.list;
      }
    });
  }

  /**
   * 输入框搜索
   * @return null
   */
  public inputWordBlur(): void {
    this.requestParams.page = 1;
    this.qkPage = 1;
    this.getPeriodicalList();
  }

  /**
   * 期刊关键字搜索
   * @return null
   */
  public onSearchPeriodical(): void {
    this.requestParams.page = 1;
    this.requestParams.keyword = this.keywords;
    this.getPeriodicalList();
  }

  /**
   * 导购选择器获得焦点事件
   * @return null
   */
  public clickGuiderSelect(): void {
    if (isEmpty(this.siteValue)) { this.$message.warning('请先选择店铺'); }
  }

  /**
   * 当前选择的导购
   * @param value
   * @return null
   */
  public selectGuider(value): void {
    this.requestParams.guiderCode = value;
    this.requestParams.page = 1;
    this.qkPage = 1;
    this.getPeriodicalList();
  }

  /**
   * 校验是否可以选择
   * @param row
   * @return {boolean}
   */
  public checkSelectAble(row): boolean {
    return row.qiKanState != 2; // 未过期数据
  }

  /**
   * 选中的期刊
   * @param val
   * @return null
   */
  public handleSelectionChange(val): void {
    this.multipleSelection = val;
    this.isSelected = val.length > 0;
  }

  /**
   * 批量操作：0禁用，1启用
   * @param {number} type
   * @return null
   */
  public batchOperation(type: number): void {
    if (!this.isSelected) {
      return;
    }
    const self = this;
    const periodicalIdList = collect(self.multipleSelection).pluck('qiKanId').toArray();
    const postParams = {
      qiKanIds: periodicalIdList,
      qiKanState: type,
    };
    this.updatePeriodicalState(postParams);
  }

  /**
   * 禁用/启用 操作
   * @param id
   * @param type
   * @return null
   */
  public changeState(id, type): void {
    this.$confirm(`确认${type !== 0 ? '上架' : '下架'}？`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      const postParams = {
        qiKanIds: [id],
        qiKanState: type,
      };
      this.updatePeriodicalState(postParams);
    });
  }

  /**
   * 二维码预览
   * @param id
   * @return null
   */
  public previewCode(id: number): void {
    const self = this;
    self.getCodeUrl(id);
  }

  /**
   * 清除定时器
   * @return null
   */
  public closeTimer(): void {
    this.isShowCode = false;
  }

  /**
   * 期刊表格当前页
   * @param val
   * @return null
   */
  public handleQKCurrentChange(val): void {
    this.qkPage = val;
    this.requestParams.page = val;
    this.getPeriodicalList();
  }

  /**
   * 选择的排序
   * @param val
   * @return null
   */
  public sortChange(val): void {
    const sortStr = val.prop + val.order;
    switch (sortStr) {
      case 'seeNumascending': // 访问量正序
        this.requestParams.sort = 2;
        break;
      case 'seeNumdescending': // 访问量倒序
        this.requestParams.sort = 1;
        break;
      case 'zanNumascending': // 点赞正序
        this.requestParams.sort = 4;
        break;
      case 'zanNumdescending': // 点赞倒序
        this.requestParams.sort = 3;
        break;
      case 'shareNumascending': // 分享正序
        this.requestParams.sort = 6;
        break;
      case 'shareNumdescending': // 分享倒序
        this.requestParams.sort = 5;
        break;
      case 'recordNumascending': // 留言正序
        this.requestParams.sort = 8;
        break;
      case 'recordNumdescending': // 留言倒序
        this.requestParams.sort = 7;
        break;
      case 'saleNumascending': // 购买正序
        this.requestParams.sort = 10;
        break;
      case 'saleNumdescending': // 购买倒序
        this.requestParams.sort = 9;
        break;
      default:
        this.requestParams.sort = 0;
        break;
    }
    this.requestParams.page = 1;
    this.qkPage = 1;
    this.getPeriodicalList();
  }

  /**
   * 每页显示条数
   * @param val
   * @return null
   */
  public selectedQkPageNum(val): void {
    this.requestParams.pageNum = val;
    this.requestParams.page = 1;
    this.qkPage = 1;
    this.getPeriodicalList();
  }

  /**
   * 留言表格当前页
   * @param {number} val
   * @return null
   */
  public handleCMCurrentChange(val: number): void {
    this.commentPage = val;
    this.commentParams.page = val;
    this.getCommentsList();
  }

  /**
   * 每页显示条数
   * @param {number} val
   * @return null
   */
  public selectedCommentPageNum(val: number): void {
    this.commentParams.pageSize = val;
    this.commentParams.page = 1;
    this.commentPage = 1;
    this.getCommentsList();
  }

  /**
   * 获取期刊路径 api 用于生成二维码
   * @param {number} id
   * @return null
   */
  public getCodeUrl(id: number): void {
    const postParams = {
      qiKanId: id,
    };
    IPSService.adminPublishQiKanDisplay({ postParams }).then((responseData) => {
      if (isset(responseData, 'qiKanUrl')) {
        this.imageView = responseData.qiKanUrl;
        this.isShowCode = true;
      }
    });
  }

  /**
   * 选中的留言
   * @return null
   */
  public selectionCommentChange(val): void {
    this.selectedComments = val;
    this.isComments = val.length > 0;
  }

  /**
   * 留言批量操作：0-隐藏 1-显示
   * @param {number} type
   * @return null
   */
  public batchComments(type: number): void {
    if (!this.isComments) {
      return
    }
    const commentIdList = collect(this.selectedComments).pluck('commentId').toArray();
    const postParams = {
      qiKanId: this.qiKanId,
      commentIdList,
      state: type,
    };
    this.updateCommentsState(postParams);
  }

  /**
   * 隐藏/显示 操作
   * @param id
   * @param type
   * @return null
   */
  public updateComment(id, type): void {
    const postParams = {
      qiKanId: this.qiKanId,
      commentIdList: [id],
      state: type,
    };
    this.updateCommentsState(postParams);
  }

  /**
   * 当前选择的留言状态
   * @param value
   * @return null
   */
  public commentStatusChange(value): void {
    this.commentParams.state = value;
    if (value === 'all') { delete this.commentParams.state; }
    // this.commentParams.page = 1;
    this.saleSitePage = 1;
    this.commentList = [];
    this.getCommentsList();
  }

  /**
   * 清除留言搜索记录
   * @return null
   */
  public clearComState(): void {
    this.isShowComment = false;
    this.comStatus = '';
    this.commentParams.keyword = '';
    this.comKeyword = '';
  }

  /**
   * 当前输入的留言关键字
   * @return null
   */
  public getCommentWord() {
    this.commentList = [];
    this.mergeParam = {
      keyword: this.comKeyword,
      page: 1,
      pageSize: 20,
    };

    this.getCommentsList();
  }

  mergeParam: any = {};
  /**
   * 期刊的评论列表
   * @param siteCodeList
   */
  // public showComments(siteCodeList): void {
  //   // this.periodicalId = id;
  //   this.commentList = [];
  //   this.mergeParam = {
  //     siteCodes: siteCodeList,
  //   };
  //   this.getCommentsList();
  // }

  /**
   * 改变期刊状态 禁用/启用 api
   * @param postParams
   * @return null
   */
  public updatePeriodicalState(postParams): void {
    IPSService.qikanStateEdit({ postParams }).then((responseData) => {
      if (responseData.result) {
        this.$message.success('操作成功');
        if (this.requestParams.qiKanState != 10) {
          this.requestParams.page = 1;
          this.qkPage = 1;
        }
        this.getPeriodicalList();
      } else {
        this.$message.error('操作失败');
      }
    });
  }

  /**
   * 改变留言的状态 api
   * @param postParams
   * @return null
   */
  public updateCommentsState(postParams): void {
    IPSService.updateCommentStatus({ postParams }).then((responseData) => {
      if (responseData.ret) {
        this.$message.success('操作成功');
        if (this.commentParams.state != 9) {
          this.commentParams.page = 1;
          this.commentPage = 1;
        }
        this.getCommentsList();
      } else {
        this.$message.error('操作失败');
      }
    });
  }

  /**
   * 获取留言列表(API)
   * @return null
   */
  public getCommentsList(): void {
    const postParams = {
      ...{
        siteCodes: this.siteCodeListAsTree,
        keyword: this.saleNumberKeywords,
        qiKanId: this.qiKanId,
        page: this.saleSitePage,
        pageSize: this.saleSitePageSize,
      },
      ...this.mergeParam,
    };
    IPSService.getCommentList({ postParams }).then((res) => {
      this.saleSiteTotalCount = res.count;
      if (isset(res, 'list')) {
        this.commentList
          = res.list && res.list.length
            ? res.list.map((i: any) => {
              i.createTime = moment(i.createTime).format('YYYY-MM-DD HH:mm:ss');
              return i;
            })
            : [];
      }
      this.saleNumberLoading = false
    }).catch((error) => {
      this.saleNumberLoading = false
    }), () => {
      this.saleNumberLoading = false
    };
  }


  /**
   * 获得期刊列表(API)
   * @return null
   */
  public getPeriodicalList(): void {
    this.periodicalList = [];
    const postParams = this.requestParams;
    if (this.date && this.date.length) {
      (postParams['startOfTime'] = parseSec(1, this.date[0])), (postParams['endOfTime'] = parseSec(2, this.date[1]));
      if (this.date[1] - this.date[0] > 184 * 24 * 3600 * 1000) {
        this.$message.error('更新时间跨度不能超过6个月！');
        this.date = [this.defaultStart, this.defaultEnd];
        (postParams['startOfTime'] = parseSec(1, this.date[0])), (postParams['endOfTime'] = parseSec(2, this.date[1]));
        this.ipsGetList(postParams);
        return;
      }
    }
    this.ipsGetList(postParams);
  }

  ipsGetList(postParams) {
    IPSService.getPeriodicalList({ postParams }).then((res) => {
      this.loadingState = false;
      if (isset(res, 'list')) {
        this.periodicalList = collect(res.list)
          .each((item) => {
            // 格式化数据
            item.qiKanEndTime = Functions.emptyVaribleHandler(item.qiKanEndTime);
            item.guiderName = Functions.emptyVaribleHandler(item.guiderName);
          })
          .values()
          .toArray();
        this.countNum = res.count;
      }
    });
  }


  // /**
  //  * 获得网点列表(API)
  //  * @return null
  //  */
  // public getSiteList(): void {
  //   IPSService.qikanChooseSiteList().then((res) => {
  //     if (res && res.list.length > 0) {
  //       this.siteList = res.list;
  //     }
  //   });
  // }

  /* 周期 */

  /**
   * 当组建加载时
   */
  public created() {
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-QIKAN');
    this.empCode = localStorage.getItem('empCode') || '';
    if (this.isContentBodyShow) {
      this.sendToIdList = [
        '',
        appEnvConfig.NODE_ENV + exportTypeStr.QIKAN_OPERATION + this.$store.state.empCode,
        appEnvConfig.NODE_ENV + exportTypeStr.QIKAN_OPERATION_INFO + this.$store.state.empCode,
        appEnvConfig.NODE_ENV + exportTypeStr.QIKAN_LIST + this.$store.state.empCode,
      ];
      this.requestParams.page = this.qkPage;
      this.requestParams.pageNum = 10;
      this.requestParams.sort = 0;
      this.defaultStart = parseSec(3);
      this.defaultEnd = parseSec(4);
      this.date = [this.defaultStart, this.defaultEnd];
      this.getPeriodicalList();
      // this.getSiteList();
    }
  }

  public publishQiKanRoute() {
    this.$router.push({ path: 'publishQiKan', query: { qiKanType: `${this.qiKanSelectType}`, editState: '1' } });
  }

  /**
   * 编辑期刊
   * @param qiKanId
   * @param qiKanType
   * @param row
   */
  public editorQikan(qiKanId, qiKanType, row?) {
    const editState = this.getEditState(row) ? '1' : '0';
    this.$router.push({ path: '/publishQiKan', query: { qiKanId, qiKanType, editState } });
  }

  /**
   * 网点列表显示
   * @return null
   */
  public onSiteListShow(item: ItemObject): void {
    new NewSelectSite().open({
      service: 'authTree',
      selectCodes: item.siteCodeList,
      readonly: true,
    }).then(noop, noop);

  }

  handleCloseActiveTrack() {
    this.saleNumberKeywords = '';
    this.isScaleTableVisible = false;
  }

  /** ***************运营数据开始************************* */

  /**
   * 筛选当前网点code集合
   * @param node
   */
  public findTargetSiteCodeList(node) {
    const me = this;
    if (Object.prototype.toString.call(node) === '[object Object]') {
      node = [node];
    }
    node.forEach((i) => {
      if (i.isSite) {
        this.targetSiteCodes.push(i);
      }
      if (i.children && !i.isSite) {
        me.findTargetSiteCodeList(i.children);
      }
    });
  }


  // 运营数据查询
  public onSaleNumberSearch() {
    this.saleSitePage = 1;
    this.saleSitePageSize = 10;
    this.getDataList();
  }

  // 切换pageSize
  public onSaleSiteSizeChange(val: number): void {
    this.saleSitePageSize = val;
    // this.getOperationDataList();
    this.getDataList();
  }

  // 切换分页
  public onSaleSitePageChange(val) {
    this.saleSitePage = val;
    // this.getOperationDataList();
    this.getDataList();
  }

  /**
   * 查询指定数据
   * tableDataType:
   * 1、运营数据 2、销售数据 3、留言
   */
  getDataList() {
    this.tableDataType === 2 ? this.getOperationAllList() : this.tableDataType === 1 ? this.getOperationDataList() : this.tableDataType === 3 ? this.getCommentsList() : '';
  }

  /**
   * 清除运营数据相关参数
   * @param item
   * @param type
   */
  clearoperationData() { }

  // 生成链接弹框
  openCreateQikanLink(item) {
    this.siteCodeList = item.siteCodeList;
    this.qiKanId = item.qiKanId;
    this.createQiKanVisible = true;

    if (item.publishPlatform === 1) {
      // 不需要siteCode
      this.createQikanLinkFn('notSIteCode');
    } else {
      this.createQikanLinkFn();
    }
  }

  genQiKanLink() {
    this.createQiKanSiteCode = '';
  }

  // 生成期刊链接
  createQikanLinkFn(notSIteCode?) {
    const siteCode = this.createQiKanSiteCode || this.siteCodeList[0];
    IPSService.createQiKanUrl({
      postParams: {
        siteCode: notSIteCode === 'notSIteCode' ? undefined : siteCode,
        qiKanId: this.qiKanId,
      },
    }).then((res) => {
      this.createQiKanLink = res.qiKanUrl;
    });
  }

  /**
   * 网点运营数据显示
   * @return null
   */
  public onSiteDataShow(item: ItemObject, type?: number): void {
    this.siteCodeList = item.siteCodeList;
    this.qiKanId = item.qiKanId;
    if (type === 3) {
      commentList.open({ qiKanId: this.qiKanId, siteList: this.siteCodeList });
    } else {

      this.saleNumberLoading = true;
      this.saleSitePage = 1;
      this.saleSitePageSize = 10;
      this.tableDataType = type || 1;
      this.isScaleTableVisible = true;
      this.siteCodeListAsTree = item.siteCodeList;
      this.saleListLoading=true
      console.log('qofjakj', this.tableDataType)
      this.getDataList();
    }
  }
  openSelectSiteDialog() {
    new NewSelectSite().open({
      service: 'authTree',
      selectCodes: this.siteCodeListAsTree,
      readonly: false,
    }).then((val: string[]) => {
      this.siteCodeListAsTree = val;
      this.saleSitePage = 1;
      this.saleSitePageSize = 10;
      this.saleListLoading=true
      this.getOperationDataList();
    }, noop);
  }
  // 弹窗的关闭
  activityResultDialogClose() {
    this.mergeParam = {};
    this.saleSiteTotalCount = 0;
    this.saleNumberSiteList = [];
    this.siteCodeListAsTree = [];
  }

  // 获取运营数据
  public getOperationDataList() {
    const postParams = {
      siteCodes: this.siteCodeListAsTree,
      keyword: this.saleNumberKeywords,
      qiKanId: this.qiKanId,
      sort: 1,
      page: this.saleSitePage,
      pageSize: this.saleSitePageSize,
    };
    IPSService.qiKanSiteOperationInfo({ postParams }).then((res) => {
      this.saleListLoading=false
      this.saleSiteTotalCount = res.count;
      this.saleNumberSiteList = res.list;
      this.siteId = res.list[0].siteId;
    }, ()=>{
      this.saleListLoading=false
    });
  }

  /** ***************运营数据结束************************* */

  /** ***************销售数据开始************************* */
  // 获取销售数据
  public getOperationAllList() {
    const postParams = {
      siteCode: this.siteCodeListAsTree[0],
      keyword: this.saleNumberKeywords,
      qiKanId: this.qiKanId,
      sort: 1,
      page: this.saleSitePage,
      pageSize: this.saleSitePageSize,
    };
    IPSService.qiKanAllSiteOperationInfo({ postParams }).then((res) => {
      this.saleListLoading=false
      this.saleSiteTotalCount = res.count;
      this.saleNumberSiteList = res.list;
    }, ()=>{
      this.saleListLoading=false
    });
  }

  public onSiteDataInfo(siteCode) {
    this.siteCodeListAsTree = [siteCode];
    this.saleSitePage = 1;
    this.saleSitePageSize = 10;
    this.saleNumberKeywords = '';
    this.tableDataType = 2;
    this.getOperationAllList();
  }

  /** ***************销售数据结束************************* */

  /**
   * 下载文件
   * @return null
   */
  public onDownLoadFile(index): void {
    location.href = this.exportBtnInfo[index].url;
    setTimeout(() => {
      this.$set(this.exportBtnInfo, index, {
        state: 0,
        url: '',
      });
    }, 2000);
  }

  exportParams(index, type = 0) {
    const postParams = {
      exportType: 'ptAct',
      params: {
        qiKanId: this.qiKanId,
        keyword: this.saleNumberKeywords,
        sort: 1,
        exportType: index === 1 ? exportType.QIKAN_OPERATION : index === 2 ? exportType.QIKAN_OPERATION_INFO : '',
      },
    };
    if (!type) {
      if (this.tableDataType === 2) {
        postParams.params['siteCode'] = this.siteCodeListAsTree[0];
      } else {
        postParams.params['siteCodes'] = this.siteCodeListAsTree;
      }
      return postParams;
    } else {
      const postParams = {
        exportType: 'qiKan',
        params: {
          keyword: this.keywords,
          qiKanState: isNumber(this.peridicalState) ? this.peridicalState : 10,
          publishPlatform: isNumber(this.publishPlatform) ? this.publishPlatform : 9,
          sort: 0,
        },
      };
      if (this.date && this.date.length) {
        (postParams.params['startOfTime'] = parseSec(1, this.date[0])), (postParams.params['endOfTime'] = parseSec(2, this.date[1]));
      }
      return postParams;
    }
  }

  /**
   * 拷贝url
   */
  public onCopyUrl() {
    Functions.clickCopy(this.createQiKanLink, '链接拷贝成功');
  }

  /**
   * 预览
   */
  public previewQiKan(val) {
    IPSService.qikanListPreview({
      postParams: {
        qiKanId: val,
      },
    }).then((response) => {
      imgPreview.open({ img: response.qiKanUrl }).then(noop, noop);
    });
  }
}
